import { Container } from '@mui/material';
import type { PageProps } from 'gatsby';
import React from 'react';

import { RoleGuard } from '@components/Guards';

import { RoleName } from '@constants/role_name';

import AppLayout from '@layouts/AppLayout';

import { Header } from '@views/Insights/index';

export default function PatientParameterPage({ params: { id } }: PageProps) {
  return (
    <RoleGuard roles={[RoleName.Practitioner]}>
      <AppLayout>
        <Container sx={{ py: 2 }}>
          <Header id={id} />
        </Container>
      </AppLayout>
    </RoleGuard>
  );
}
